import { Mapper } from "../../../../../base/utils/mapper";
import { ServiceModel } from "../../../../../domain/models/configuration/company/service.model";
import { ServiceEntity } from "../../entities/company/service.entity";

export class ServiceImplementationRepositoryMapper extends Mapper<ServiceEntity, ServiceModel> {
    mapFrom(param: ServiceEntity): ServiceModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ServiceModel): ServiceEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}